
<div 
  #swiper
  class="register-user-form__container"
>
  <ul class="register-user-form__items swiper-wrapper">
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-form-step-1 [form]="form()" />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-form-step-2 [form]="form()" />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-form-step-3 [form]="form()" />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-form-step-4 [form]="form()" />
      </article>
    </li>
    
    <li class="register-user-form__item swiper-slide">
      <article class="register-user-form__article">
        <app-form-step-5 [form]="form()" />
      </article>
    </li>
  </ul>
  
  <div class="swiper-pagination"></div>
  
  <app-navigation-buttons [form]="form()" />
</div>